import $ from "jquery";
import { contentMeta, createGuid } from "./general_functions";
import language from "./translation";
import { getLangForApi } from "#scripts/cmsapi.js";

import { getImageByContentId, getImage } from "./images";
import breadcrumb from '../templates/pages/breadcrumb';

export const setNews = (news) => {

    let newsList = [];

    $.each(news.listOfContent, function (a, b) {

        let date = new Date(b.firstCreated);

        let pDate = ('0' + date.getDate()).slice(-2) + '.' +
            ('0' + (date.getMonth() + 1)).slice(-2) + '.' +
            date.getFullYear();

        newsList.push(`
                <div class="newslist__item__frontpage">
                    <h3 class="newslist__header">
                        <a href="/article/${b.contentId}" class="newslist__link"><span>${b.title}</span></a>
                    </h3>
                    <p class="newslist__intro">${b.intro}</p>
                    <div class="newslist__date text-right">${pDate}</div>
                </div>`);

    });

    newsList = newsList.join("");

    return newsList;

};

export const getNews = (num = 3, from = 0, callback) => {

    let clientid = client.clientId;

    // const ga = $.getJSON(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${clientid}/mal_nyhet/${num}/${from}/Modified`).done((result) => {
    //${window.apiUrl}/api/Public/articles?subscriptionId=${client.clientId}&category=${category}&language=${getLangForApi()}&contentTypes=${defaultContentTypes.join(",")}&IncludeCategories=true&limit=${load}&getRecursiveContent=true&sortBy=Title&LanguageMode=Strict`
    const defaultContentTypes = ["73da834a-d2cf-4659-ab23-760986ecbfde"];
    const ga = $.getJSON(window.apiUrl + `/api/Public/articles?subscriptionId=${clientid}&language=${getLangForApi()}&contentTypes=${defaultContentTypes.join(",")}&IncludeCategories=true&limit=${num}&offset=${from}&getRecursiveContent=true&sortBy=Modified&LanguageMode=Strict`).done((result) => {

        callback(result);

    });

};

export const setFrontNews = (num = 3) => {

    getNews(num, 0, function (result) {

        let news = setNews(result);

        $("#news").html(news);

        if (result.totalCount > num) {
            $("#news").append(`
            <div class="news__summary text-right">
                <a href="/liste/nyheter" class="newslist__seeall">${language("NEWS_SEEALL")}</a>
            </div>
            `);
        }

    });


};

export const setNewsList = (from, loadNum) => {

    const breadcrumbHtml = breadcrumb();

    loadNum = loadNum || 10;
    from = from || 0;

    getNews(loadNum, from, function (result) {

        // console.log("News", result);

        // if (result.totalCount > loadNum) {
        //     console.log("spose need More than 25");
        // }

        let availablenews = result.totalCount;
        let to = loadNum + from;

        let newsList = [];

        $.each(result.listOfContent, function (a, b) {

            let date = new Date(b.firstCreated);



            let pDate = ('0' + date.getDate()).slice(-2) + '-' +
                ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                date.getFullYear();

            let meta = contentMeta(b);

            // console.log("meta", meta);

            let img = "";
            let width = "col-sm-12";

            if (meta.imageContentId !== undefined && meta.imageContentId.length && !client.noImagesInNewslist > 0) {
                let imgId = createGuid();
                width = "col-sm-8";
                img = `
                    <div class="col-sm-4 image__container">
                        <img src="" alt="" class="article__introimage" id="${imgId}" >
                    </div>`;

                //console.log('getImageByContentId: + ' + meta.imageContentId);
                getImageByContentId(meta.imageContentId, (img) => {
                    if (img.url !== undefined && img.url.length > 0) {
                        $(`#${imgId}`).attr("src", img.url);
                    }
                });
            }

            newsList.push(`
                <div class="newslist__item">
                <a href="/article/${b.contentId}" >
                    <div class="row">
                        ${img}
                        <div class="${width}">
                            <div class="newslist__content">
                                <h3 class="newslist__header" class="newslist__link">
                                    <!--a href="/article/${b.contentId}" class="newslist__link"-->${b.title}<!--/a-->
                                </h3>
                                <p class="newslist__intro">${b.intro}</p>
                                <div class="newslist__date">${pDate}</div>
                            </div>
                        </div>
                    </div>
                    </a>
                </div>`);
        });

        $("#currentPageBreadcrumb").text(document.title);
        newsList = newsList.join("");

        $(".newslist__list").append(newsList);


        const newslist__header = `
            <div class="row">
                <div class="col mt-5">
                    <p>
                        ${language("NEWS_PAGEIN_1")} ${(from + 1)} ${language("NEWS_PAGEIN_2")} ${availablenews > to ? to : availablenews} ${language("NEWS_PAGEIN_3")} ${availablenews}
                    </p>
                </div>
            </div>
        
        `;

        //$(".newslist__info").html(newslist__header);

        if (availablenews > loadNum) {

            let pages = Math.ceil(availablenews / loadNum);

            // console.log(pages);

            let pageslinks = [];
            let i = 0;

            for (i = 0; i < pages; i++) {

                pageslinks.push(`
                    <li class="page-item ${(i * loadNum) === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${(i * loadNum)}" >${(i + 1)}</a></li>`);

            }

            pageslinks = pageslinks.join("");

            const newslist__footer = `
            
            <div class="row">
                <div class="col mt-5">
                
                    <nav aria-label="${language("NEWS_BROWSEPAGES")}">
                      <ul class="pagination  pagination-lg">
                        ${pageslinks}
                      </ul>
                    </nav>
                    
                </div>
            </div>
            
            `;

            $(".newslist__footer").html(newslist__footer);
        }

    });

    $("body").off("click", ".news__page__links");

    $("body").on("click", ".news__page__links", function (e) {
        e.preventDefault();
        const num = $(this).data("from");
        setNewsList(parseInt(num));

        // window.scroll({
        //     top: 0,
        //     left: 0,
        //     behavior: 'smooth' // This makes the scroll smooth
        // });

    });

    // window.contentID = "00000000-0000-0000-0000-000000000000";
    // window.contentSubscription = client.clientId;
    // window.fantdu__success = function(result) {
    //     let traces = [];
    //     result.trace.$values.forEach(data => {
    //         let time = data.timeOut / 1000;
    //         traces.push(`
    //             <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${decodeURIComponent(data.pageName)}</a></li>
    //        `)
    //     });

    //     let comment = ``;
    //     // console.log(result.comment, result.comment.length, comment)

    //     if (result.comment.length > 0) {
    //         console.log("comment inside", result.comment);
    //         comment = `${result.comment}`;
    //     }

    //     // console.log("result - fantdu : ", result)
    //     traces = traces.join("");

    //     let fantdu__comment = `<span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
    //         <br/>
    //         ${comment}
    //         <br/><br/>
    //         <h6>Sporing:</h6>
    //         <ol>
    //         ${traces}
    //         </ol>
    //     `;

    //     let data = {
    //         "taskFinished": false,
    //         "taskDescription": fantdu__comment,
    //         "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
    //         "subscriptionId": contentSubscription,
    //         "contentId": contentID,
    //         "taskState": 0,
    //         "taskType": "FantDu"
    //     };

    //     // console.log("data fantdu: ", data);
    //     let senddata = JSON.stringify(data);
    //     // console.log("sendata fantdu ok", senddata);

    //     // Get JSON 
    //     $.ajax({
    //         type: "POST",
    //         url: window.apiUrl + "/api/UserTaskApi/create",
    //         contentType: "application/json-patch+json",
    //         data: senddata,
    //         headers: { "subscriptionId": client.clientId }
    //     }).done(function(alle) {

    //     });
    // }

    // window.fandu__failed = function(result) {

    //     let traces = [];

    //     result.trace.$values.forEach(data => {

    //         let time = data.timeOut / 1000;

    //         traces.push(`
    //             <li>${time} sek, <a href="${data.pageUrl}">${data.pageName}</a></li>
    //        `)

    //     });

    //     let comment = ``;

    //     if (result.comment.length > 0) {
    //         comment = `${result.comment}`;
    //     }
    //     // console.log("result - fantdu : ", result)
    //     traces = traces.join("");

    //     let fantdu__comment = `
    //         Fantdu feilet, returnerer res etter stat:<br>
    //         <span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
    //         <br/>
    //         ${comment}
    //         <br/><br/>
    //         <h6>Sporing:</h6>
    //         <ol>
    //         ${traces}
    //         </ol>
    //     `;

    //     let data = {
    //         "taskFinished": false,
    //         "taskDescription": fantdu__comment,
    //         "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
    //         "subscriptionId": contentSubscription,
    //         "contentId": contentID,
    //         "taskState": 0,
    //         "taskType": "FantDu"
    //     };

    //     let senddata = JSON.stringify(data);
    //     // console.log("sendata fantdu error", senddata);

    //     // Get JSON
    //     $.ajax({
    //         type: "POST",
    //         url: window.apiUrl + "/api/UserTaskApi/create",
    //         contentType: "application/json-patch+json",
    //         data: senddata,
    //     }).done(function(alle) {

    //     });
    // }

    $("#maincontent").html(`
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="newslist col-md-${client.noImagesInNewslist ? `7` : `10`}">

                    <h1 class="page__header">${language("NEWS_NEWS")}</h1>
                    <div class="newslist__info"></div>
                    <div class="newslist__list"></div>
                    <div class="newslist__footer"></div>
                
                </div>
            </div>
        </div>
        <div class="fant_du_container">
            <fant-du client="${client.nameId}" onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="
                button.fant-du__button {
                    border-color: var(--fantdu__border__color, var(--primary__color));border-radius:0;
                }
                textarea.fant-du__textarea {
                    background-color: #ffffff;
                }
                "></fant-du> 
        </div>
    `);

}
